import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { components } from 'react-select';

const DepartureOption = ({ option, onMouseDown,  ...props }) =>
    <components.Option onMouseDown={onMouseDown} {...props}>
        <i className="value-icon fa fa-bus" />
        <span className="option-title"> {option.stop.title}</span>
        {!isEmpty(option.step) && <span className="option-title-sep"> - </span>}
        {!isEmpty(option.step) && <span className="option-subtitle">{option.step.title}</span>}
        {!isEmpty(option.locality) && <span className="option-title-sep"> - </span>}
        {!isEmpty(option.locality) && <span className="option-subtitle">{option.locality.title}</span>}
    </components.Option>
;

export default DepartureOption;
